require("@rails/ujs").start()
require('jquery')
const WOW = require('wow.js')

import './css/style.css'
import './css/animate.min.css'
import './fonts/fonts.css'
import './css/media.css'

$(document).ready(function() {
  new WOW().init();

  var $form = $('.feedback__form');
  $form.on('submit', function(e) {
    e.preventDefault();
    $form.find("[required]").each(function(){
      if( $(this).val() == '')  {
        $(this).addClass("warning");
      } else {
        $(this).removeClass("warning");
      }
    })

    if ($form.find("[required].warning").length) return false

    $.post($form.attr('action'), $form.serialize(), function(resp){
      if (resp?.status == 'success') {
        $form.slideUp();
        $form.nextAll('.feedback__thanks').slideDown();
        $form.nextAll('.error').text('').slideUp();
      } else {
        $form.nextAll('.error').html(resp?.errors?.join('<br>') || 'Something went wrong.').slideDown();
      }
    })
    return false;
  })
});
